module.exports = __webpack_public_path__ + "phone-graphs.2rrKBCbj.svg";